/*
*   table with database for order to doctor
*
* appears in <div class="database__main" id="orderbase" data-controller="orderbase"></div>

*/


import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css'
import 'datatables.net-fixedcolumns-dt';
import 'datatables.net-fixedheader-dt';
import 'datatables.net-responsive-dt';
import 'datatables.net-scroller-dt';
import 'select2/dist/js/select2.min'
import 'select2/dist/css/select2.min.css'
import {fetchStaffs} from "../services/staff";

import datetimepicker from 'jquery-datetimepicker'
import {Modal} from "bootstrap";
import mask from 'jquery-mask-plugin'
import * as neffos from "../neffos.min"
import { openAppointmentModal } from '../modules/appointmentModal';
import {log} from "qrcode/lib/core/galois-field";



export default class extends Controller {
    table;
    tableOrders;
    WhoIs;
    fullDoctorList = [];
    filteredDoctorList = [];
    dataBaseScheduleStart;
    dataBaseScheduleFinish;
    dataBaseScheduleCurrent = new Date();
    badges = [];
    occupationModal;
    intervalId;
    minClientAge = '';
    salonsList = [];
    staffs = [];

    initialize(){
        super.initialize();

        /* твиги для вывода ячеек времени с разными статусами */
        Twig.twig({
            id: "schedule-item-free", //controller name
            href: "/twig/s-item-free.twig",// loadable twig
            async: false
        });
        Twig.twig({
            id: "schedule-item-block", //controller name
            href: "/twig/s-item-block.twig",// loadable twig
            async: false
        });
        Twig.twig({
            id: "schedule-item-busy", //controller name
            href: "/twig/s-item-busy.twig",// loadable twig
            async: false
        });
        Twig.twig({
            id: "schedule-item-offdays", //controller name
            href: "/twig/s-item-offdays.twig",// loadable twig
            async: false
        });
    }
    conn;

    //checking authorization
    checkToken(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
            if(this.WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar)
        }
    }

    //logout from authorization
    logout(){
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        let nameVar = Twig.twig({ref: "authorization"}).render({});
        $('#authorization').html(nameVar)
    }

    //create a list of doctors in the select
    getDoctorsList(){
        let jsDoctorList = $('#js-doctors-list');

        if(this.fullDoctorList.length === 0){
            this.fullDoctorList = api.doctorList('doctor');
        }

        let user = api.WhoIs();
        const schedulers = {
            "scheduler": [
                "ADK",
                "AKT",
                "AKU",
                "ATR",
                "CIM",
                "DS2",
                "DST",
                "FRM",
                "MG2",
                "MGA",
                "KER",
                "KRC",
                "MGS",
                "SAR",
            ],
            "scheduler2":[
                "ADK",
                "AKT",
                "AKU",
                "ATR",
                "CIM",
                "DS2",
                "DST",
                "FRM",
                "MG2",
                "MGA",
                "KER",
                "KRC",
                "MGS",
                "SAR",
            ],
            "scheduler3":[
                "ADK",
                "AKT",
                "AKU",
                "ATR",
                "CIM",
                "DS2",
                "DST",
                "FRM",
                "MG2",
                "MGA",
                "KER",
                "KRC",
                "MGS",
                "SAR",
            ],
            "scheduler4":[
                "ADK",
                "AKT",
                "AKU",
                "ATR",
                "CIM",
                "DS2",
                "DST",
                "FRM",
                "MG2",
                "MGA",
                "KER",
                "KRC",
                "MGS",
                "SAR",
            ],
            "scheduler5":[
                "ADK",
                "AKT",
                "AKU",
                "ATR",
                "CIM",
                "DS2",
                "DST",
                "FRM",
                "MG2",
                "MGA",
                "KER",
                "KRC",
                "MGS",
                "SAR",
            ],
            "scheduler6":[
                "ADK",
                "AKT",
                "AKU",
                "ATR",
                "CIM",
                "DS2",
                "DST",
                "FRM",
                "MG2",
                "MGA",
                "KER",
                "KRC",
                "MGS",
                "SAR",
            ]
        }

        let salons = schedulers[user.UserName];

        this.filteredDoctorList = this.fullDoctorList.filter((item)=>{
            return salons.includes(item.StoreCode);
        })



        this.fullDoctorList.forEach((item)=>{
            let name = item.Name.replace(/(\S+) (\S{1})(\S+) (\S{1})(\S+)/, "$1 $2.$4.");

            if (salons.includes(item.StoreCode)){
                jsDoctorList.append('<option value="'+item.StaffID+'" selected="selected">'+name+' ('+item.StoreCode+')</option>');
            } else {
                jsDoctorList.append('<option value="'+item.StaffID+'">'+item.Name+' ('+item.StoreCode+')</option>');
            }
        });

        jsDoctorList.select2({
            placeholder: 'Нажмите, чтобы выбрать врача/врачей',
            //maximumSelectionLength: maxSelectLength
        });

        /*        jsDoctorList.on('select2:select', function (e) {
                    let data = e.params.data;
                    console.log(data);
                });*/
        self = this;
        jsDoctorList.on("select2:select", function (e) {
            let index = self.fullDoctorList.findIndex(object => {
                return object.StaffID === Number(e.params.data.id);
            });
            self.filteredDoctorList.push(self.fullDoctorList[index]);
            let column  = self.table.column(index +1).visible(true);
        });


        jsDoctorList.on("select2:unselect", function (e) {

            const index = (self.fullDoctorList.findIndex(object => {
                return object.StaffID === Number(e.params.data.id);
            }))
            let column  = self.table.column(index +1).visible(false);
        });
    };

    getPatientInfo(event){
        //console.debug(event.params.customerid);
        if (event.params.customerid !== null && event.params.customerid !== 0){
            let patient = api.searchPatient(event.params.customerid);
            let patientDateBirth = new Date(patient.ClientDateBirth).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
            $('#patientDateBirth-'+event.params.id+'').text(patientDateBirth);
            $('#patientClientAge-'+event.params.id+'').text(patient.ClientAge);
        }
    }

    blockTime(event){
        let blockTimeData = $($('#blockTime-'+event.params.id)[0]).serializeObject();
        if (blockTimeData.reason === ''){
            $('#blockTime-'+event.params.id+' label').append('<strong id="blockTimeAlert-'+event.params.id+'" style="color: red; display: inline-block; padding-left: 10px">заполните поле!</strong>');
            setTimeout(function() {
                    $('#blockTimeAlert-'+event.params.id).remove();
                },
                5000);
        } else {
            let result = api.blockTime(blockTimeData);
            $('#check-'+event.params.id).prop('checked', false);
            if (result.Status === 200 ){
                this.table.row(event.params.row).invalidate().draw();
            }
        }

    }

    setPrepaid(event){
        let prepaid = $($('#prepaidForm-'+event.params.id)[0]).serializeObject();
        if (prepaid.sum === ''){
            $('#prepaidFormAlert-'+event.params.id).remove();
            $('#prepaidForm-'+event.params.id).append('<strong id="prepaidFormAlert-'+event.params.id+'" style="color: red; display: flex; width: 100%; padding:3px 0 0">заполните поле!</strong>');
            setTimeout(function() {
                    $('#prepaidFormAlert-'+event.params.id).remove();
                },
                5000);
            return
        }
        const hasOnlyDigits = (v) => /^\d+$/.test(v);

        if(!hasOnlyDigits(Number(prepaid.sum))){
            $('#prepaidFormAlert-'+event.params.id).remove();
            $('#prepaidForm-'+event.params.id).append('<strong id="prepaidFormAlert-'+event.params.id+'" style="color: red; display: flex; width: 100%; padding:3px 0 0">только цифры!</strong>');
            setTimeout(function() {
                    $('#prepaidFormAlert-'+event.params.id).remove();
                },
                5000);
            return
        }

        let result = api.setPrepaid(prepaid.orderId, prepaid.sum);
        $('#check-'+event.params.id).prop('checked', false);
        if (result.Status === 200 ){
            this.table.row(event.params.row).invalidate().draw();
        }
    }

    isApproved(event){
        let result = api.isApproved(event.params.dataid);
        if (result.Status === 200 ){
            this.table.row(event.params.row).invalidate().draw();
        }
    }

    closeNote(event){
        $('#check-'+event.params.id).prop('checked', false);
        $('#check-'+event.params.id).attr('checked', false);
    }

    filteredChangeDoctorList(){
        let inFilter;
        let inIndex;
        this.fullDoctorList.forEach((item, index)=>{
            inIndex = index;
            inFilter = this.filteredDoctorList.findIndex((object)=>{
                return object.StaffID === item.StaffID
            })
            if (inFilter === -1){
                let column  = self.table.column(inIndex +1).visible(false);
            }

        })
    }

    // data current
    dataCurrent(){
        let currentDate = new Date();
        $('#sheduleDate').text(currentDate);
    }

    countPeriodData(event){
        self = this;

        if(event.params.period === 'today'){
            console.log('start today')
            this.dataBaseScheduleStart = new Date();
            this.dataBaseScheduleStart.setHours(10);
            this.dataBaseScheduleStart.setMinutes(0);
            this.dataBaseScheduleStart.setSeconds(0);

            this.dataBaseScheduleFinish = new Date();
            this.dataBaseScheduleFinish.setHours(20);
            this.dataBaseScheduleFinish.setMinutes(0);
            this.dataBaseScheduleFinish.setSeconds(0);

        } else if(event.params.period === 'yesterday') {
            console.log('start yesterday')

            this.dataBaseScheduleStart = new Date();
            this.dataBaseScheduleStart.setDate(this.dataBaseScheduleStart.getDate()  - 1);
            this.dataBaseScheduleStart.setHours(11);
            this.dataBaseScheduleStart.setMinutes(0);
            this.dataBaseScheduleStart.setSeconds(0);

            this.dataBaseScheduleFinish = new Date();
            this.dataBaseScheduleFinish.setDate(this.dataBaseScheduleFinish.getDate()  - 1);
            this.dataBaseScheduleFinish.setHours(20);
            this.dataBaseScheduleFinish.setMinutes(0);
            this.dataBaseScheduleFinish.setSeconds(0);

        } else if(event.params.period === 'week') {
            console.log('start week')

            this.dataBaseScheduleStart = new Date();
            this.dataBaseScheduleStart.setHours(10);
            this.dataBaseScheduleStart.setMinutes(0);
            this.dataBaseScheduleStart.setSeconds(0);

            this.dataBaseScheduleFinish = new Date();
            this.dataBaseScheduleFinish.setDate(this.dataBaseScheduleFinish.getDate()  + 7);
            this.dataBaseScheduleFinish.setHours(20);
            this.dataBaseScheduleFinish.setMinutes(0);
            this.dataBaseScheduleFinish.setSeconds(0);

        } else if(event.params.period === 'twoWeek') {
            console.log('start twoWeek')

            this.dataBaseScheduleStart = new Date();
            this.dataBaseScheduleStart.setHours(10);
            this.dataBaseScheduleStart.setMinutes(0);
            this.dataBaseScheduleStart.setSeconds(0);

            this.dataBaseScheduleFinish = new Date();
            this.dataBaseScheduleFinish.setDate(this.dataBaseScheduleFinish.getDate()  + 13);
            this.dataBaseScheduleFinish.setHours(20);
            this.dataBaseScheduleFinish.setMinutes(0);
            this.dataBaseScheduleFinish.setSeconds(0);
        }
        console.log(event.params.period)
        console.log('countPeriodData start:', this.dataBaseScheduleStart.toString());
        console.log('countPeriodData finish:', this.dataBaseScheduleFinish.toString());
        console.log('countPeriodData start ts:', this.dataBaseScheduleStart.getTime());
        console.log('countPeriodData finish ts:', this.dataBaseScheduleFinish.getTime());
        this.table.draw();

    }

    countRandomPeriodData(){
        let doctorDbStart = ($('#doctorDb-start').val()).replace(/(\d+).(\d+).(\d+)/,"$3-$2-$1");
        let doctorDbFinish = ($('#doctorDb-finish').val()).replace(/(\d+).(\d+).(\d+)/,"$3-$2-$1");
        this.dataBaseScheduleStart = new Date(doctorDbStart);
        this.dataBaseScheduleStart.setHours(10);
        this.dataBaseScheduleStart.setMinutes(0);
        this.dataBaseScheduleStart.setSeconds(0);

        this.dataBaseScheduleFinish = new Date(doctorDbFinish);
        this.dataBaseScheduleFinish.setHours(20);
        this.dataBaseScheduleFinish.setMinutes(0);
        this.dataBaseScheduleFinish.setSeconds(0);
        this.table.draw();
    }

    openAppointmentModal(event){
        openAppointmentModal.call(this, event);
    }

    cancelOrder(event){
        let cancelOrderData = $($('#canselOrderForm-'+event.params.id)[0]).serializeObject();
        if (cancelOrderData.canselReason === ''){
            $('#canselOrderForm-'+event.params.id+' .canselOrder__title').append('<strong id="blockTimeAlert-'+event.params.id+'" style="color: red; display: inline-block; padding-left: 10px">заполните поле!</strong>');
            setTimeout(function() {
                    $('#blockTimeAlert-'+event.params.id).remove();
                },
                5000);
            return
        }
        let result = api.cancelOrder(cancelOrderData.orderId,cancelOrderData.canselReason);
        $('#check-'+event.params.id).prop('checked', false);
        if (result.Status === 200 ){
            this.table.row(event.params.row).invalidate().draw();
        }

    }

    closeNote(event){
        $('#check-'+event.params.id).prop('checked', false);
    }

    //output database for DOCTOR scheduler
    buildTable() {

        $.fn.dataTable.ext.errMode = 'none';
        self = this;

        //устанвливаем дефолтно текущий день
        this.dataBaseScheduleStart = new Date();
        this.dataBaseScheduleStart.setHours(10);
        this.dataBaseScheduleStart.setMinutes(0);
        this.dataBaseScheduleStart.setSeconds(0);

        this.dataBaseScheduleFinish = new Date();
        this.dataBaseScheduleFinish.setHours(20);
        this.dataBaseScheduleFinish.setMinutes(0);
        this.dataBaseScheduleFinish.setSeconds(0);

        this.table = $('#orderbaseList').DataTable({
            language: {
                url: 'data/dataTables.ru.json'
            },
            fixedHeader: false,
            lengthChange: false,
            searching: false,
            paging: false,
            info: false,
            /*            scrollX: true,
                        scrollY:        400,*/
            deferRender: true,
            scroller: false,
            serverSide: true,
            processing: true,
            initComplete: function () {
                self.filteredChangeDoctorList();
            },

            ajax: {
                url: global.api_url + '/schedule/datatable',
                headers: {'Authorization': 'Bearer ' + sessionStorage.getItem('token')},
                type: 'post',
                data: (data) => {
                 /*   console.log('start:', this.dataBaseScheduleStart.toString());
                    console.log('finish:', this.dataBaseScheduleFinish.toString());
                    console.log('start ts:', this.dataBaseScheduleStart.getTime());
                    console.log('finish ts:', this.dataBaseScheduleFinish.getTime());*/
                    data.Filter = {
                        'positivId': '82',
                        'interval': '30 minute', // было 1 hour
                        'start': Math.trunc(this.dataBaseScheduleStart.getTime() / 1000).toString(),
                        'finish': Math.trunc(this.dataBaseScheduleFinish.getTime() / 1000).toString(),
                    };
                    return JSON.stringify(data);
                },
                contentType: "application/json",
                error: (error) => {
                    console.debug(error);
                }
            },
            columns: this.getColumnsDatatable()
        });

        fetchStaffs({status: 'all'}).then((fetchStaffsArray) => {
            const staffs = {};
            fetchStaffsArray.data.forEach(item => {
                staffs[item.staff_id] = item;
            });
            this.staffs = staffs;

            if (this.table) {
                this.table.draw(false);
            }
        });

    }

    getColumnsDatatable(){
        let columns = [];
        columns.push({
            orderable: false,
            searchable: false,
            data: 't',
            name: 't',
            title: '',
            visible: false, /* <== скрыли колонку с датами 08.2023 */
            render: ((data, type, full, meta)=>{
                let scheduleDate = new Date(data);
                let daysWeek = [
                    'Вс',
                    'Пн',
                    'Вт',
                    'Ср',
                    'Чв',
                    'Пт',
                    'Сб'
                ];
                let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
                let n = scheduleDate.getDay();
                let scheduleDateHours  = scheduleDate.getHours();
                let scheduleDateMinutes  = scheduleDate.getMinutes();
                if (scheduleDateHours < 10) {
                    scheduleDateHours = "0" + scheduleDateHours;
                }
                if (scheduleDateMinutes < 10) {
                    scheduleDateMinutes = "0" + scheduleDateMinutes;
                }

                let scheduleOnlyTime =  scheduleDateHours + ":" + scheduleDateMinutes;

                if (scheduleDate.getHours() === 11){
                    return '<div class="scheduleDateBox">' +
                        '<div class="scheduleDateCalendar">' +
                        '<span class="scheduleDateBox__month">'+months[scheduleDate.getMonth()]+'</span>' +
                        '<span class="scheduleDateBox__date">'+scheduleDate.getDate()+'</span>' +
                        '<span class="scheduleDateBox__daysWeek">'+daysWeek[n]+'</span>' +
                        '</div>' +
                        '<span class="scheduleOnlyTime">'+scheduleOnlyTime+'</span>' +
                        '</div>'
                } else {
                    return '<div class="scheduleDateBox scheduleDateBoxSingle"><span class="scheduleOnlyTime">'+scheduleOnlyTime+'</span></div>'
                }

            })
        });




        this.fullDoctorList.forEach((item)=>{
            self = this;
            self.badges[item.StaffID] = 0
            let colTitle = '<div class="colTitleBox"><span class="colTitle">'+item.Name.replace(/(\S+) (\S+) (\S+)/, "$1<br> $2<br> $3")+'</span></div>';
            let doctorId = item.StaffID;
            columns.push({
                data: 'd'+ item.StaffID,
                name: '*',
                title: colTitle,
                searchable: false,
                orderable: false,
                width: "10%",
                'createdCell': function(td, cellData, rowData, row, col) {
                    let cellId = 'cell-'+item.StaffID+'-'+new Date(rowData.t).getTime()
                    $(td).attr('id', cellId);
                },
                render: ((data, type, full, meta)=>{
                    /*!!! ячейка времени настройки !!!*/

                    //ID для ячейки = ID  доктора + timestamp ячейки
                    let timeItemID = doctorId+'-'+new Date(full.t).getTime();

                    //узнаем контроллер
                    let controllerName = $('.database__main').attr("id");

                    let doctorDate = new Date(full.t);
                    let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                        "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];

                    let doctorTimeHours = new Date(full.t).toLocaleTimeString(
                        "ru-RU",
                        {
                            minute:'2-digit',
                            hour:'2-digit'
                        });
                    //считаем прошедшее время - для класса. если time_passed - ячейка времени НЕ активна
                    let timePassed = "";
                    let timePassedDisabled = "";
                    if(new Date() > doctorDate){
                        timePassed = 'time_passed';
                        timePassedDisabled = 'disabled="disabled"'
                    }
                    let orderDateTimeFrom = new Date(full.t).getTime();
                    let orderDateTimeTo = Number(orderDateTimeFrom) + 30 * 60 * 1000;
                    //это дата
                    let orderDateDayToUser = new Date(orderDateTimeFrom).toLocaleDateString(
                        'ru-RU',
                        {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        });
                    //время от и до
                    let orderDateFromTimeToUser = new Date(orderDateTimeFrom).toLocaleTimeString(
                        'ru-RU',
                        {
                            hour: "2-digit",
                            minute: "2-digit"
                        });
                    let orderDateToTimeToUser = new Date(Number(orderDateTimeTo)).toLocaleTimeString(
                        'ru-RU',
                        {
                            hour: "2-digit",
                            minute: "2-digit"
                        });
                    //коды салонов для ячеек
                    let currentDoctorSalon = 'выходной';
                    if (data.SalonId !== ''){
                        const findSalon = this.salonsList.find(item => item.store_id == data.SalonId);
                        currentDoctorSalon = findSalon.store_cod
                    }
                    //создаем уникальный ID
                    let unitId = doctorId+''+meta.col+''+meta.row;





                    //время для ячейки
                    let doctorTimeDay = doctorDate.toLocaleDateString('ru-KZ', { year: 'numeric', month: 'numeric', day: 'numeric' });
                    let doctorMinutes = doctorDate.getMinutes(); //!! ДЛЯ ПРОВЕРКИ - УДАЛИТЬ

                /*
                   //считаем прошедшее время
                    let timePassed = '';
                    let doctorPassTime = doctorDate;
                    let timePassedDisabled = "";
                    doctorPassTime.setMinutes(0);
                    doctorPassTime.setSeconds(0);
                    doctorPassTime.setMilliseconds(0);
                    if(new Date() > doctorPassTime){
                        timePassed = 'time_passed';
                        timePassedDisabled = 'disabled="disabled"'
                    }
                     let orderDateTimeFrom = new Date(full.t).getTime();
                    let orderDateTimeTo = Number(orderDateTimeFrom) + 30 * 60 * 1000;



                       //настройки локализации
                    const dayOption = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                    const timeOption = { hour: "2-digit", minute: "2-digit" };
                    //это дата
                    let orderDateDayToUser = new Date(Number(orderDateTimeFrom));
                    orderDateDayToUser = orderDateDayToUser.toLocaleDateString('ru-KZ', dayOption);
                    //время от и до
                    let orderDateFromTimeToUser = new Date(Number(orderDateTimeFrom));
                    orderDateFromTimeToUser = orderDateFromTimeToUser.toLocaleTimeString('ru-KZ', timeOption);
                    let orderDateToTimeToUser = new Date(Number(orderDateTimeTo));
                    orderDateToTimeToUser = orderDateToTimeToUser.toLocaleTimeString('ru-KZ', timeOption);
                    */

                    let statusDoctorName ='';//!! ДЛЯ ПРОВЕРКИ - УДАЛИТЬ
                    let statusDoctorClass ='';//!! ДЛЯ ПРОВЕРКИ - УДАЛИТЬ
                    let orderInfo = '';//!! ДЛЯ ПРОВЕРКИ - УДАЛИТЬ
                    let collapseDoctorOff = '';//!! ДЛЯ ПРОВЕРКИ - УДАЛИТЬ


                    let informationBlock = '';//!! ДЛЯ ПРОВЕРКИ - УДАЛИТЬ





                    /* выходной */
                    if (data.ClientsCustomerID === null && data.ClientsStaffID === null && data.Reason === 'offDays'){
                        let content = Twig.twig({ref: "schedule-item-offdays"}).render({
                            'currentDoctorSalon':currentDoctorSalon,
                            'doctorDate':doctorDate.getDate(),
                            'doctorTimeHours': doctorTimeHours,
                            'monthName': months[doctorDate.getMonth()],
                            'timeItemID':timeItemID,
                            'timePassed': timePassed,
                            'unitId': unitId,
                        });
                        return content
                    }

                    /* рабочее свободное время */
                    if (data.Reason === null && data.ClientsCustomerID === null && data.ClientsStaffID === null ){
                        console.log(data)
                        console.log(data.SalonId)
                        let content = Twig.twig({ref: "schedule-item-free"}).render({
                            'clientsCustomerID': data.ClientsCustomerID,
                            'controllerName':controllerName,
                            'currentDoctorSalon': currentDoctorSalon,
                            'doctorDate':doctorDate.getDate(),
                            'doctorTimeHours': doctorTimeHours,
                            'itemMinPatientAge': item.MinPatientAge,
                            'itemName': item.Name,
                            'salon_id': data.SalonId,
                            'itemStaffID': item.StaffID,
                            'metaRow': meta.row,
                            'monthName': months[doctorDate.getMonth()],
                            'orderDateDayToUser': orderDateDayToUser,
                            'orderDateFromTimeToUser': orderDateFromTimeToUser,
                            'orderDateToTimeToUser': orderDateToTimeToUser,
                            'orderDateTimeFrom': orderDateTimeFrom,
                            'orderDateTimeTo': orderDateTimeTo,
                            'timePassed': timePassed,
                            'unitId': unitId,
                            'timeItemID':timeItemID,
                            // 'informationBlock': informationBlock,
                        });
                        return content
                    }

                    //рабочее занятое время
                    if (data.Reason !== 'offDays' && data.ClientsCustomerID !== null && data.ClientsCustomerID !== '' && data.Type === 'BUSINESS'){
                        let selfAppointment = parseInt(JSON.parse(data.Notes).selfAppointment);
                        let manager = this.staffs[JSON.parse(data.Notes).manager];
                        let managerName = 'Не известно';

                        if (manager) {
                            managerName = manager.description.name;
                        } else if (selfAppointment) {
                            managerName = 'Самостоятельная Запись';
                        }

                        let clientName = data.Reason.split(":");
                        clientName = clientName[1];
                        let diagnosticType = '';
                        let isApprovedText = '';
                        let amauntIcon = '';
                        let switchStatus = '';
                        let statusDoctorClass ='';
                        if(data.IsApproved){
                            isApprovedText = 'подтвержден';
                            statusDoctorClass = 'isApproved'
                            switchStatus = 'checked'
                        } else {
                            isApprovedText = 'не подтвержден';
                            statusDoctorClass = 'noApproved'
                        }
                        diagnosticType = global.globalFuncs.DiagnosticTypes.getDiagnosticTypeTitle(data.DiagnosticType)

                        let notes = (data.Notes).replace(/['"{}]/g, '').split(",");
                        let doctorScheduleComment = "<span class='form-text text-muted'>нет комментария</span>";
                        let doctorScheduleLargeComment = '';
                        let doctorScheduleVisit = "";
                        let doctorScheduleWhoWrote = "";
                        let doctorScheduleWhoWroteStatus = '';
                        let doctorScheduleComeFrom = '';
                        let doctorSchedulePatientAge = '';
                        notes.forEach((item)=> {
                            let notesData = item.split(":");
                            if (notesData[0].trim() === 'comment') {
                                if (notesData[1] === ''){
                                    doctorScheduleComment = "<span class='form-text text-muted'>нет комментария</span>";
                                } else{
                                    doctorScheduleComment = notesData[1].trim();
                                    doctorScheduleComment = doctorScheduleComment.replaceAll('|', '<br>');
                                    if (doctorScheduleComment.length > 50){
                                        doctorScheduleLargeComment = 'datatableDoctorOrderInfo__comment--large'
                                    }
                                }
                            }
                            if (notesData[0] === 'visit') {
                                doctorScheduleVisit = global.globalFuncs.ScheduleVisit.getVisitTypeTitle(notesData[1]) ||  notesData[1]
                            }
                            if (notesData[0] === 'doctor') {
                                doctorScheduleWhoWroteStatus = 'врач';
                                doctorScheduleWhoWrote = notesData[1];
                                doctorScheduleComeFrom = 'салон'
                            }
                            if (notesData[0] === 'manager') {
                                doctorScheduleWhoWroteStatus = 'менеджер';
                                doctorScheduleWhoWrote = notesData[1];
                                doctorScheduleComeFrom = 'салон'
                            }
                            if (notesData[0] === 'ref') {
                                doctorScheduleWhoWroteStatus = 'пациент';
                                doctorScheduleComeFrom = notesData[1]
                            }
                            if (notesData[0] === 'clientAge') {
                                doctorSchedulePatientAge = notesData[1]
                            }
                        });

                        //start - end visit
                        let orderStart = new Date(data.Start).toLocaleTimeString(
                            'ru-KZ',
                            {
                                hour: "2-digit",
                                minute: "2-digit"
                            });
                        let orderEnd = new Date(data.Finish).toLocaleTimeString(
                            'ru-KZ',
                            {
                                hour: "2-digit",
                                minute: "2-digit"
                            });

                        if (data.PrepayAmount !== null){
                            amauntIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon amauntIcon"><circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line></svg>'
                        }
                        amauntIcon;
                        let prepayAmountText = data.PrepayAmount;
                        if (prepayAmountText === null){
                            prepayAmountText = '';
                        }

                        let content = Twig.twig({ref: "schedule-item-busy"}).render({
                            'clientsCustomerID': data.ClientsCustomerID,
                            'clientName': clientName,
                            'managerName': managerName,
                            'controllerName': controllerName,
                            'currentDoctorSalon': currentDoctorSalon,
                            'dataIsApproved': data.IsApproved,
                            'dataID': data.ID,
                            'diagnosticType': diagnosticType,
                            'doctorDate':doctorDate.getDate(),
                            'doctorScheduleComment':doctorScheduleComment,
                            'doctorScheduleLargeComment': doctorScheduleLargeComment,
                            'doctorScheduleVisit':doctorScheduleVisit,
                            'doctorTimeHours': doctorTimeHours,
                            'isApprovedText':isApprovedText,
                            'itemName': item.Name,
                            //'itemStaffID': item.StaffID,
                            'metaRow': meta.row,
                            'monthName': months[doctorDate.getMonth()],
                            'orderDateDayToUser': orderDateDayToUser,
                            'orderStart':orderStart,
                            'orderEnd': orderEnd,
                            'patientDateBirth': '',
                            'patientClientAge': '',
                            'prepayAmountText':prepayAmountText,
                            'statusDoctorClass': statusDoctorClass,
                            'switchStatus': switchStatus,
                            'timeItemID':timeItemID,
                            'timePassed': timePassed,
                            'timePassedDisabled': timePassedDisabled,
                            'unitId': unitId,
                        });
                        return content
                    }

                    //рабочее заблокированное время
                    if(data.Reason !== 'offDays' && data.ClientsCustomerID !== null && data.ClientsCustomerID !== '' && data.Type === 'PERSONAL'){
                        let content = Twig.twig({ref: "schedule-item-block"}).render({
                            'clientsCustomerID': data.ClientsCustomerID,
                            'controllerName': controllerName,
                            'currentDoctorSalon': currentDoctorSalon,
                            'doctorDate':doctorDate.getDate(),
                            'dataReason': data.Reason,
                            'dataID': data.ID,
                            'doctorTimeHours': doctorTimeHours,
                            'itemName': item.Name,
                            'monthName': months[doctorDate.getMonth()],
                            'orderDateDayToUser': orderDateDayToUser,
                            'orderDateFromTimeToUser': orderDateFromTimeToUser,
                            'orderDateToTimeToUser': orderDateToTimeToUser,
                            'timeItemID':timeItemID,
                            'timePassed': timePassed,
                            'unitId': unitId,
                        });
                        return content

                    }


                    //создаем куда все положим
                    return '<div class="datatableDoctorOrderBox" >' +
                        '<div class="collapseDoctor datatableDoctorOrderStatus datatableDoctorOrderStatus-'+statusDoctorClass+' '+timePassed+'" id="collapseDoctor-'+unitId+'" data-action="click->orderbase#getPatientInfo" data-orderbase-id-param="'+unitId+'" data-orderbase-customerid-param="'+data.ClientsCustomerID+'">' +
                        '<input type="radio" name="collapseDoctorCheck" class="togCheck" id="check-'+unitId+'">' +
                        '<label class="datatableDoctorDescr" for="check-'+unitId+'">' +
                        /*'<span class="datatableDoctorDay">'+doctorTimeDay+ '</span>'+*/
                        '<span class="datatableDoctorDay">' +
                        '<span class="datatableDoctorDay__Number">'+doctorDate.getDate()+'</span>' +
                        '<span class="datatableDoctorDay__Monthname">'+months[doctorDate.getMonth()]+'</span>' +
                        '</span>' +
                        '<span class="datatableDoctorTime">'+doctorTimeHours+':'+doctorMinutes+ '</span>'+
                        /*'<span class="time-status">'+statusDoctorName+'</span>' +*/
                        '<span class="datatableDoctorSalon">'+currentDoctorSalon+'</span>' +
                        '</label>' +
                        '<div class="datatableDoctorOrderInfo '+informationBlock+'" id="datatableDoctorOrderInfo-'+unitId+'"><span class="close" id="close-'+unitId+'" data-action="click->orderbase#closeNote" data-orderbase-id-param="'+unitId+'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#212529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=""><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg></span>\n' +
                        orderInfo +
                        '</div>' +
                        '</div>' +

                        '  </div>\n' +
                        '</div>' +
                        '</div>'



                })
            });
        })

        return columns
    }

    tableRefresh(){
        this.table.draw();
    }

    async connectNote() {
        const wsURL = global.wsURL;

        try {
            this.conn = await neffos.dial(wsURL, {
                default: { // "default" namespace.
                    _OnNamespaceConnected: function (nsConn, msg) {
                        if (nsConn.conn.wasReconnected()) {
                            console.debug('wasReconnected')
                        }
                        console.debug('connected')
                    },
                    _OnNamespaceDisconnect: function (nsConn, msg) {
                        console.debug('Disconnect')
                    },
                    onAddOccupation:function (nsConn, msg) { // добавлена запись
                        self.onAddOccupation(nsConn, msg);
                    },
                    onBlockOccupation:function (nsConn, msg) { // добавлен блок
                        self.onBlockOccupation(nsConn, msg)
                    },
                    onDeleteOccupation:function (nsConn, msg) { // удалена запись/блок
                        self.table.ajax.reload(null,false);
                    },
                }
            });

            this.conn.connect("default");
        } catch (err) {
            console.log(err);

        }
    }

    onAddOccupation(nsConn, msg){
        let userAllData = JSON.parse(msg.Body);
        let userInfo = userAllData.request;
        let userRecordInfo = userAllData.result;
        let basicTime = Number(userInfo.orderDateTimeFrom);
        let basicTimeEnd = Number(userInfo.orderDateTimeTo);
        for(let t = basicTime;t < basicTimeEnd; t+= 30 * 60 * 1000){
            let cellTimeItemID = 'cell-'+userInfo.doctorId+'-'+t;
            let currentDoctorSalon = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-currentDoctorSalon');
            let itemName = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-doctorName');
            let metaRow = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-metaRow');
            let unitId = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-unitId');

            let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];

            let doctorDate = new Date(basicTime).getDate();
            let monthName = months[new Date(basicTime).getMonth()];
            let diagnosticType = global.globalFuncs.DiagnosticTypes.getDiagnosticTypeTitle(userInfo.orderServiceList)

            let doctorScheduleComment = "<span class='form-text text-muted'>нет комментария</span>";
            let doctorScheduleLargeComment = '';
            let doctorScheduleVisit = "";
            let doctorScheduleWhoWrote = "";
            let doctorScheduleWhoWroteStatus = '';
            let doctorScheduleComeFrom = '';
            let doctorSchedulePatientAge = '';
            let clientAge = '';


            let userInfoInfo = userInfo.info;
            for (let key in userInfoInfo) {
                let userInfoInfoData = userInfoInfo[key];
                if (key === 'comment'){
                    if (userInfoInfoData === ''){
                        doctorScheduleComment = "<span class='form-text text-muted'>нет комментария</span>";
                    } else {
                        doctorScheduleComment = userInfoInfoData.replaceAll('|', '<br>');
                        if (doctorScheduleComment.length > 50){
                            doctorScheduleLargeComment = 'datatableDoctorOrderInfo__comment--large'
                        }
                    }

                }
                if (key === 'visit'){
                    doctorScheduleVisit = global.globalFuncs.ScheduleVisit.getVisitTypeTitle(userInfoInfoData) ||  userInfoInfoData
                }
                if (key === 'doctor'){
                    doctorScheduleWhoWroteStatus = 'врач';
                    doctorScheduleWhoWrote = userInfoInfoData;
                    doctorScheduleComeFrom = 'салон'
                }
                if (key === 'manager'){
                    doctorScheduleWhoWroteStatus = 'менеджер';
                    doctorScheduleWhoWrote = userInfoInfoData;
                    doctorScheduleComeFrom = 'салон'
                }
                if (key === 'ref'){
                    doctorScheduleWhoWroteStatus = 'пациент';
                    doctorScheduleComeFrom = userInfoInfoData
                }
                if (key === 'clientAge') {
                    doctorSchedulePatientAge = userInfoInfoData;
                    clientAge = userInfoInfoData;
                }

            }
            //let dataID = userRecordInfo.object[0];
            let dataID = '';
            for (let key in userRecordInfo.object){
                if (userRecordInfo.object[key] === 'new id'){
                    dataID = Number(key);
                }
            }

            let doctorTimeHours = new Date(t).toLocaleTimeString(
                "ru-RU",
                {
                    minute:'2-digit',
                    hour:'2-digit'
                });
            let orderDateDayToUser = new Date(t).toLocaleDateString(
                'ru-RU',
                {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            let orderStart = new Date(basicTime).toLocaleTimeString(
                'ru-KZ',
                {
                    hour: "2-digit",
                    minute: "2-digit"
                });
            let orderEnd = new Date(basicTimeEnd).toLocaleTimeString(
                'ru-KZ',
                {
                    hour: "2-digit",
                    minute: "2-digit"
                });
            let prepayAmountText = "";
            let timeItemID = userInfo.doctorId+'-'+t;
            //считаем прошедшее время - для класса. если time_passed - ячейка времени НЕ активна
            let timePassed = "";
            let timePassedDisabled = "";
            if(new Date() > new Date(t)){
                timePassed = 'time_passed';
                timePassedDisabled = 'disabled="disabled"'
            }
            let controllerName = $('.database__main').attr("id");

            let content = Twig.twig({ref: "schedule-item-busy"}).render({
                'clientsCustomerID': "",
                'controllerName': controllerName,
                'patientClientAge': clientAge,
                'clientName': userInfo.clientName+' '+userInfo.clientSurname+' '+userInfo.clientPhone,
                'patientDateBirth': userInfo.clientDateBirth,
                'currentDoctorSalon': currentDoctorSalon,
                'dataIsApproved': 'isApproved',
                'dataID': dataID,
                'diagnosticType': diagnosticType,
                'doctorDate': doctorDate,
                'doctorScheduleComment':doctorScheduleComment,
                'doctorScheduleLargeComment': doctorScheduleLargeComment,
                'doctorScheduleVisit':doctorScheduleVisit,
                'doctorTimeHours': doctorTimeHours,
                'isApprovedText':'подтвержден',
                'itemName': itemName,
                'metaRow': metaRow,
                'monthName': monthName,
                'orderDateDayToUser': orderDateDayToUser,
                'orderStart':orderStart,
                'orderEnd': orderEnd,
                'prepayAmountText':prepayAmountText,
                'statusDoctorClass': 'isApproved',
                'switchStatus': 'checked',
                'timeItemID':timeItemID,
                'timePassed': timePassed,
                'timePassedDisabled': timePassedDisabled,
                'unitId': unitId,
            });

            $('#'+cellTimeItemID).html(content);
        }
    }

    onBlockOccupation(nsConn, msg){
        let userAllData = JSON.parse(msg.Body);
        let userInfo = userAllData.request;
        let userRecordInfo = userAllData.result;
        let basicTime = Number(userInfo.orderDateTimeFrom);
        let basicTimeEnd = Number(userInfo.orderDateTimeTo);
        let cellTimeItemID = 'cell-'+userInfo.doctorId+'-'+basicTime;
        let currentDoctorSalon = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-currentDoctorSalon');
        let itemName = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-doctorName');
        let metaRow = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-metaRow');
        let unitId = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-unitId');

        let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
            "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];

        let doctorDate = new Date(basicTime).getDate();
        let monthName = months[new Date(basicTime).getMonth()];
        let dataID = '';
        for (let key in userRecordInfo.object){
            if (userRecordInfo.object[key] === 'new id'){
                dataID = Number(key);
            }
        }
        let doctorTimeHours = new Date(basicTime).toLocaleTimeString(
            "ru-RU",
            {
                minute:'2-digit',
                hour:'2-digit'
            });
        let orderDateDayToUser = new Date(basicTime).toLocaleDateString(
            'ru-RU',
            {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        let orderDateFromTimeToUser = new Date(basicTime).toLocaleTimeString(
            'ru-KZ',
            {
                hour: "2-digit",
                minute: "2-digit"
            });
        let orderDateToTimeToUser = new Date(basicTimeEnd).toLocaleTimeString(
            'ru-KZ',
            {
                hour: "2-digit",
                minute: "2-digit"
            });
        let timeItemID = userInfo.doctorId+'-'+basicTime;
        let dataReason = userInfo.reason;
        let controllerName = $('.database__main').attr("id");

        //считаем прошедшее время - для класса. если time_passed - ячейка времени НЕ активна
        let timePassed = "";
        let timePassedDisabled = "";
        if(new Date() > new Date(basicTime)){
            timePassed = 'time_passed';
            //timePassedDisabled = 'disabled="disabled"'
        }
        let content = Twig.twig({ref: "schedule-item-block"}).render({
            'clientsCustomerID': "",
            'controllerName': controllerName,
            'currentDoctorSalon': currentDoctorSalon,
            'doctorDate': doctorDate,
            'dataID': dataID,
            'doctorTimeHours': doctorTimeHours,
            'itemName': itemName,
            'monthName': monthName,
            'orderDateDayToUser': orderDateDayToUser,
            'orderDateFromTimeToUser': orderDateFromTimeToUser,
            'orderDateToTimeToUser': orderDateToTimeToUser,
            'dataReason': dataReason,
            'timeItemID':timeItemID,
            'timePassed': timePassed,
            'unitId': unitId,
        });
        $('#'+cellTimeItemID).html(content);
    }

    connect(){

        // we turn to twig, indicate which controller to use, inside we transfer the data
        let content = Twig.twig({ref: "orderbase"}).render({});

        let token = sessionStorage.getItem('token');
        if (token === null ){
            this.logout();
        }

        //specify the block and display the contents of the twig in it
        $('#orderbase').html(content);

        //create a list of doctors in the select
        this.getDoctorsList();

        //count dates
        this.dataCurrent();

        //output database
        this.buildTable();

        //salon list
        this.salonsList = api.salonsList();

        //refresh scheduler every 10 minutes
        self = this;
        self.intervalId = setInterval(()=>{
                //console.debug('reload:', new Date().toLocaleString("ru-RU"));
                let date = new Date();
                if (date.getHours() < 10 ||  date.getHours() > 21){
                    return
                }
                this.occupationModal.hide();
                self.buildTable.ajax.reload()
            },
            600000);
        /* 600000 = 10 minutes*/

        //for date field
        let self = this;
        $.datetimepicker.setLocale('ru');
        $('#doctorDb-start').datetimepicker({
            timepicker:false,
            format:'d.m.Y',
        });

        $('#doctorDb-finish').datetimepicker({
            timepicker:false,
            format:'d.m.Y',
        });
        //server
        this.connectNote();
    }

    disconnect(){
        this.conn.close();
    }
}
